import { makeObservable, action, observable } from 'mobx';
import { IRecommendListDTO } from '@/components/Search/components/Recommends/typings';
import StoreBase from './Base';
import { SearchTracker } from '@/utils/Tracker';
import { getRecommends } from '@/service/search';
import { enableStaticRendering } from 'mobx-react';
import { MobxStore } from './types';

enableStaticRendering(typeof window === 'undefined');

// 缓存时间5分钟
const CACHE_TIME = 5 * 60 * 1000;

class SearchStore extends StoreBase<'search'> {
  @observable
  /** 搜索推荐 */
  recommends: IRecommendListDTO[] = [];

  @observable
  showSearchBar: boolean = false;
  constructor(props: MobxStore) {
    super(props);
    makeObservable(this);
  }

  /** 缓存时间 */
  @observable
  recommendExpireTimestamp: number = 0;

  cacheIsExpired = () => {
    return this.recommendExpireTimestamp < Date.now();
  };
  @action
  updateRecommendsCache = () => {
    /** 更新缓存的时机有
     * 1、全局搜索框打开
     * 2、搜索结果页聚焦
     * 3、搜索结果页搜索框搜索内容长度小于等于1时
     */
    // 缓存过期，重新获取
    if (this.cacheIsExpired()) {
      // 记录原过期时间
      const originTs = this.recommendExpireTimestamp;
      // 设置新的过期时间，用作防抖
      this.recommendExpireTimestamp = Date.now() + CACHE_TIME;
      getRecommends()
        .then((res) => {
          // 过滤掉子项数组为空的
          this.recommends = res.filter((item) => {
            return item.recommendItems.length > 0;
          });
        })
        .catch((err) => {
          console.error(err);
          // 请求失败，还原缓存过期时间
          this.recommendExpireTimestamp = originTs;
        });
    }
  };

  @action
  /** 开启/关闭全局搜索栏 */
  toggleSearchBar = () => {
    this.showSearchBar = !this.showSearchBar;
    // 搜索埋点 - 放大镜点击
    if (this.showSearchBar) {
      SearchTracker.searchBarTracing({
        action: 'search_tab_click',
      });
    }
  };

  @action
  /** 关闭全局搜索栏 */
  closeSearchBar = () => {
    this.showSearchBar = false;
  };
}

export default SearchStore;
